const banner = {
  getlist: 'banner/getlist',
  add: 'banner/add',
  update: 'banner/update',
  remove: 'banner/remove',
  get: 'banner/get',
  getall: 'banner/getall',
}
export default banner
